import { captureException } from "@sentry/react";

const reported = new Set<string>();

/**
 * Report a Tggl call made without a `<TgglProvider>` in the tree — once per unique caller, to avoid
 * log/Sentry spam on re-render. Shared by the `useFlag` and `useTggl` wrappers.
 */
export function reportMissingTgglProvider(caller: string) {
	if (reported.has(caller)) {
		return;
	}

	reported.add(caller);

	const error = new Error(
		`Tggl was used without a <TgglProvider> in the tree (${caller}). The call was skipped / fell back to its default. Wrap the app in <TgglProvider> to enable Tggl.`,
	);

	console.error(error);
	captureException(error, { level: "warning", tags: { tggl: "missing-provider", caller } });
}
